var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.rowData[_vm.fieldData.fieldCode]
    ? _c("el-tag", { attrs: { size: "mini" } }, [
        _vm._v(_vm._s(_vm.rowData[_vm.fieldData.fieldCode])),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }